import React, {useContext, useEffect, useState} from "react";
import _ from "lodash";
import MultiCurrencyDashboardDetails from "./MultiCurrencyDashboardDetails";
import DashboardDetails from "./DashboardDetails";
import {ShopContext} from "../../App";
import axios from "../../axios";

const Dashboard = () => {
    const config = useContext(ShopContext);
    const [loading, setLoading] = useState(false);
    const [dashboardData, setDashboardDetails] = useState({
        totalAbandonedCheckoutsDetails: [],
        totalRecoveredCheckoutsDetails: [],
        store_currencies: []
    });
    useEffect(() => {
        setLoading(true);
        axios.get(`/dashboard`, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        }).then((response) => {
            setLoading(false);
            setDashboardDetails(response.data)
        }).catch(() => {
            setLoading(false);
        });
    }, [config]);
    let defaultDashboardDetails = {
        abandonedCheckoutsDetails: [],
        recoveredCheckoutsDetails: [],
        storeCurrencies: []
    }
    let dashboardDetails = {...defaultDashboardDetails, ...dashboardData}
    if (dashboardDetails.storeCurrencies.length > 1) {
        return (<MultiCurrencyDashboardDetails
            abandonedCheckouts={dashboardDetails.abandonedCheckoutsDetails}
            RecoveredCheckouts={dashboardDetails.recoveredCheckoutsDetails}
            currencies={dashboardDetails.storeCurrencies}
            loading={loading}
        />)
    } else {
        let data = {};
        if (_.has(dashboardDetails.abandonedCheckoutsDetails, 0)) {
            let abandonedTotal = parseFloat(_.get(dashboardDetails.abandonedCheckoutsDetails, `0.total`, '0.00'));
            data.totalAbandonedCheckouts = parseInt(_.get(dashboardDetails.abandonedCheckoutsDetails, `0.count`, '0'));
            data.totalAbandonedRevenue = abandonedTotal.toFixed(2);
        }
        if (_.has(dashboardDetails.recoveredCheckoutsDetails, 0)) {
            let recoveredTotal = parseFloat(_.get(dashboardDetails.recoveredCheckoutsDetails, `0.total`, '0.00'));
            data.totalRecoveredCheckouts = parseInt(_.get(dashboardDetails.recoveredCheckoutsDetails, `0.count`, '0'));
            data.totalRecoveredRevenue = recoveredTotal.toFixed(2);
        }
        return (
            <DashboardDetails loading={loading} dashboardData={data} currency={_.get(dashboardDetails.storeCurrencies, `0`, '')}/>
        );
    }
}

export default Dashboard;
